import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import SvgIcon from '@components/SvgIcon'

interface DatePublishedProps {
  children?: string
}

const StyledDatePublished = styled.div`
  ${({
    theme: {
      typography: {
        catchword: {
          small1: { bundledCSS: catchwordSmall1CSS },
        },
      },
      spacing: { spacing2, spacing16 },
      colors: { textWeak },
    },
  }) => css`
    ${catchwordSmall1CSS};
    box-sizing: border-box;
    padding-left: ${spacing16};
    text-align: right;
    color: ${textWeak};
    display: flex;
    align-items: center;
    gap: ${spacing2};
  `}
`

const StyledSvgIcon = styled(SvgIcon)``

const DatePublished: FunctionComponent<DatePublishedProps> = ({ children }) => {
  const theme = useTheme()
  return (
    <StyledDatePublished suppressHydrationWarning={true}>
      <StyledSvgIcon
        iconName="clock-three"
        color={theme.colors.iconWeak}
        size={18}
      />
      {children}
    </StyledDatePublished>
  )
}

export default DatePublished
